import { render, staticRenderFns } from "./edit-discount.vue?vue&type=template&id=662008ab&"
import script from "./edit-discount.vue?vue&type=script&lang=js&"
export * from "./edit-discount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports